// @ts-nocheck
import { X } from 'lucide-react';
import { CenteredModal } from './CenteredModal';
import { workflowToolbarPrimaryButtonClass } from './WorkflowFormPrimitives';

const TITLE_ID = 'error-detail-modal-title';

/** Read-only modal for displaying a full error message from a table row. */
export const ErrorDetailModal = ({ open, title, subtitle, message, onClose }) => (
  <CenteredModal open={open} onClose={onClose} maxWidthClass="max-w-lg" titleId={TITLE_ID}>
    <div className="px-5 py-4 border-b border-gray-100 flex items-start justify-between gap-3">
      <div className="min-w-0">
        <p id={TITLE_ID} className="text-xs font-medium text-gray-900">
          {title}
        </p>
        {subtitle ? (
          <p className="text-xs font-normal text-gray-500 mt-0.5 truncate" title={subtitle}>
            {subtitle}
          </p>
        ) : null}
      </div>
      <button
        type="button"
        onClick={onClose}
        className="flex-shrink-0 rounded-md p-1 text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors"
        aria-label="Close"
      >
        <X size={14} />
      </button>
    </div>
    <div className="px-5 py-4">
      <p className="text-xs font-normal text-red-700 whitespace-pre-wrap break-words">{message}</p>
    </div>
    <div className="px-5 py-3 border-t border-gray-100 flex justify-end">
      <button type="button" onClick={onClose} className={`${workflowToolbarPrimaryButtonClass} px-4 py-2`}>
        Close
      </button>
    </div>
  </CenteredModal>
);
